import type {TedIntonationSpan} from '@/types/screenplay';
import {performanceAttributes} from '@/utils/performanceAttributes';
import {SPEECH_LANGUAGES,type SpeechLanguage} from '@/utils/speechLanguage';

/** Hovered attributes belong below the script, never over editable text. */
export default function PerformanceAttributeGutter({span,language}:{span?:TedIntonationSpan|null;language?:SpeechLanguage}){
  // Intensity is derived from delivery styles, not a user-facing status item.
  // Keep all authored voice, cue and AI controls, plus the block-level language.
  const attributes=span?performanceAttributes(span).filter(attribute=>attribute.type!=='Emotional intensity'):[];
  if(language)attributes.push({type:'Language',value:language==='auto'?'Automatic detection':SPEECH_LANGUAGES[language]});
  return <div className="script-attribute-status" role="status" aria-label="Passage attributes" aria-live="polite">
    {attributes.length?attributes.map((attribute,index)=><span key={index}>
      <strong className="font-medium">{attribute.type==='Subtle emotion'?'Emotion':attribute.type}:</strong> {attribute.value}
    </span>):<span className="text-muted-foreground">Hover over bracketed text to see its attributes.</span>}
  </div>;
}
